import React, { forwardRef } from 'react';
import styled from 'styled-components';

import FlexColumn from '@ui/atoms/FlexColumn';

import PasswordInput from '@ui/forms/PasswordInput';

import ValidationRule from '@ui/molecules/ValidationRule';

import theme from '@theme/FolxTheme';

import TextInput, { IStyledTextInputProps } from '../TextInput';

interface IPasswordValidationInputProps extends IStyledTextInputProps {
	hasValidLength?: boolean;
	validLengthLabel?: string;
	hasUppercaseLetter?: boolean;
	validUppercaseLabel?: string;
	hasLowercaseLetter?: boolean;
	validLowercaseLabel?: string;
	hasNumber?: boolean;
	validNumberLabel?: string;
	hasMatchingPassword?: boolean;
	validMatchingLabel?: string;
	confirmInputDirty?: boolean;
}

const PasswordWrapper = styled(FlexColumn)``;

const ValidationRow = styled(FlexColumn)`
	margin-top: ${theme.spacing.sm};
	width: 100%;
`;

const PasswordValidationInput = forwardRef<HTMLInputElement, IPasswordValidationInputProps>(
	(
		{
			hasValidLength = false,
			validLengthLabel,
			hasUppercaseLetter = false,
			validUppercaseLabel,
			hasLowercaseLetter = false,
			validLowercaseLabel,
			hasNumber = false,
			validNumberLabel,
			hasMatchingPassword = false,
			validMatchingLabel,
			confirmInputDirty = false,
			className,
			...textInputProps
		},
		ref
	) => {
		return (
			<PasswordWrapper className={className}>
				<PasswordInput {...textInputProps} />
				{(validLengthLabel ||
					validUppercaseLabel ||
					validLowercaseLabel ||
					validNumberLabel ||
					validMatchingLabel) && (
					<ValidationRow>
						{validLengthLabel && <ValidationRule label={validLengthLabel} valid={hasValidLength} />}
						{validUppercaseLabel && (
							<ValidationRule label={validUppercaseLabel} valid={hasUppercaseLetter} />
						)}
						{validLowercaseLabel && (
							<ValidationRule label={validLowercaseLabel} valid={hasLowercaseLetter} />
						)}
						{validNumberLabel && <ValidationRule label={validNumberLabel} valid={hasNumber} />}
						{validMatchingLabel && confirmInputDirty && (
							<ValidationRule label={validMatchingLabel ?? ''} valid={hasMatchingPassword} />
						)}
					</ValidationRow>
				)}
			</PasswordWrapper>
		);
	}
);

PasswordValidationInput.displayName = 'PasswordValidationInput';
export default styled(PasswordValidationInput)``;
